module.exports = __webpack_public_path__ + "static/media/Group 52.ba09244d.png";